import pianoUrls from './urls';

export const listenForReload = () => {
	window.addEventListener( 'message', event => {
		if ( pianoUrls.includes( event.origin ) && event.data === 'refreshPiano' ) {
			location.reload();
		}
	} );
};
export default listenForReload;
